import React, { FC } from 'react';

import { Box } from '@chakra-ui/react';

import { WithResourceIcon } from 'components/DataDisplay';
import { FormAction } from 'components/DataEntry/Form';
import { IconTypes } from 'components/Icons';
import { Modal } from 'components/Overlay';
import { ReportingChartForm } from 'containers/Reports/ReportsDashboard/Components/ReportingChartForm';

interface Props {
  currentRecord: Record<string, any>;
  setCurrentRecord: (value: Record<string, any>) => void;
  isOpen: boolean;
  onClose: () => void;
  actionType: FormAction;
}

export const ReportChartWizard: FC<Props> = props => {
  const {
    currentRecord,
    isOpen,
    onClose,
    actionType,
    setCurrentRecord,
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={
        <WithResourceIcon
          resourceType={IconTypes.MixedChart}
          color="primary"
          iconSize="medium"
          iconStyles={{ p: 1 }}
        >
          <Box>
            {actionType === 'Add' ? 'Add Chart to Dashboard' : 'Update Chart'}{' '}
          </Box>
        </WithResourceIcon>
      }
      styles={{
        modal: { size: 'lg' },
      }}
      body={
        <ReportingChartForm
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
          onClose={onClose}
          actionType={actionType}
        />
      }
    />
  );
};
